<script>
import { api } from "@/state/services";

export default {
  components: {
  },
  data() {
    return {
      graduations: null,
      totals: {
        sales_person: 0,
        sales_team_first: 0,
        sales_team_monthly: 0,
        sponsoreds_min: 0,
      },
      previous: {
        id: null,
        name: '',
        sales_person: 0,
        sales_team_first: 0,
        sales_team_monthly: 0,
        sponsoreds_min: 0,
        image: null,
      },
      next: {
        id: null,
        name: '',
        sales_person: 0,
        sales_team_first: 0,
        sales_team_monthly: 0,
        sponsoreds_min: 0,
        image: null
      },
      progress: 0
    };
  },
  methods: {
    getGraduation() {
      api
        .get('reports/graduation')
        .then(response => {
          if (response.data.status == 'success') {
            this.graduations = response.data.list
            this.previous = response.data.graduation.previous
            this.next = response.data.graduation.next

            this.totals.sales_person = response.data.graduation.totals.sales_person
            this.totals.sales_team_first = response.data.graduation.totals.sales_team_first
            this.totals.sales_team_monthly = response.data.graduation.totals.sales_team_monthly
            this.totals.sponsoreds_min = response.data.graduation.totals.sponsoreds_min

            this.$parent.$parent.graduation.id = response.data.current.id
            this.$parent.$parent.graduation.name = response.data.current.name
            this.$parent.$parent.getStatData();
          }
        })
    }
  },
  created() {
    this.getGraduation();
  }
};
</script>

<template>
  <div class="w-100">
    <div class="row mb-4">
      <div class="col-6">
        <div class="card mb-0">
          <div class="card-body text-center p-2">
            <h5 class="my-1">{{ previous.name }}</h5>
            <div class="bg-light rounded py-1 font-size-12 text-uppercase">Atual</div>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="card mb-0">
          <div class="card-body text-center p-2">
            <h5 class="my-1">{{ next.name }}</h5>
            <div class="bg-light rounded py-1 font-size-12 text-uppercase">Próximo</div>
          </div>
        </div>
      </div>
    </div>
    <fieldset>
      <legend class="font-size-14">Vendas Pessoais</legend>
      <b-progress style="border-radius: 3px;" :value="Number(previous.sales_person)" :max="Number(next.sales_person)" variant="default" height="15px"></b-progress>
      <div class="d-flex justify-content-between">
        <h6 class="m-0">0</h6>
        <h6 class="m-0">{{ totals.sales_person | points }}</h6>
        <h6 class="m-0">{{ next.sales_person | points }}</h6>
      </div>
    </fieldset>
    <fieldset>
      <legend class="font-size-14">Novos Clientes da Equipe</legend>
      <b-progress style="border-radius: 3px;" :value="Number(previous.sales_team_first)" :max="Number(next.sales_team_first)" variant="default" height="15px"></b-progress>
      <div class="d-flex justify-content-between">
        <h6 class="m-0" v-if="next.sales_team_first > 0">0</h6>
        <h6 class="m-0" v-else>-</h6>
        <h6 class="m-0">{{ totals.sales_team_first | points }}</h6>
        <h6 class="m-0" v-if="next.sales_team_first > 0">{{ next.sales_team_first | points }}</h6>
        <h6 class="m-0" v-else>-</h6>
      </div>
    </fieldset>
    <fieldset>
      <legend class="font-size-14">Vendas Recorrentes da Equipe</legend>
      <b-progress style="border-radius: 3px;" :value="Number(previous.sales_team_monthly)" :max="Number(next.sales_team_monthly)" variant="default" height="15px"></b-progress>
      <div class="d-flex justify-content-between">
        <h6 class="m-0" v-if="next.sales_team_monthly > 0">0</h6>
        <h6 class="m-0" v-else>-</h6>
        <h6 class="m-0">{{ totals.sales_team_monthly | points }}</h6>
        <h6 class="m-0" v-if="next.sales_team_monthly > 0">{{ next.sales_team_monthly | points }}</h6>
        <h6 class="m-0" v-else>-</h6>
      </div>
    </fieldset>
    <fieldset>
      <legend class="font-size-14">Diretos Ativos</legend>
      <b-progress style="border-radius: 3px;" :value="Number(previous.sponsoreds_min)" :max="Number(next.sponsoreds_min)" variant="default" height="15px"></b-progress>
      <div class="d-flex justify-content-between">
        <h6 class="m-0" v-if="next.sponsoreds_min > 0">0</h6>
        <h6 class="m-0" v-else>-</h6>
        <h6 class="m-0">{{ totals.sponsoreds_min | points }}</h6>
        <h6 class="m-0" v-if="next.sponsoreds_min > 0">{{ next.sponsoreds_min | points }}</h6>
        <h6 class="m-0" v-else>-</h6>
      </div>
    </fieldset>
  </div>
</template>

<style scoped>
.report {
  margin-top: -80px;
}

.label {
  line-height: 13px;
}
</style>